import { Modal } from "antd";
import { ReactNode, useState } from "react";
import { DOC_STATUS_REQUESTED, STATUS_PENDING, STATUS_REQUESTED } from "../../../constants/constants";

interface Props {
    title?: string;
    item: any;
    onCancel: () => void;
    onSuccess: () => void;
    api?: any;
    content?: ReactNode
    okText?: string
    onOk?: () => void;
    width?: number
}
const DeleteModalSimple = (props: Props) => {
    const { item, onSuccess, title = "item", content, okText, width = 300 } = props;

    const [submitLoading, setSubmitLoading] = useState(false);


    const onSubmit = () => {

        if (props?.onOk && [STATUS_REQUESTED, STATUS_PENDING, DOC_STATUS_REQUESTED].includes(item?.status)) {
            props?.onOk()
        } else {
            setSubmitLoading(true);
            props?.api(item?.id).then((res: any) => {
                onSuccess();
                setSubmitLoading(false);
            }).catch((err: any) => {
                setSubmitLoading(false);
                console.error('err', err);
            })
        }


    }

    const onCancel = () => {
        props?.onCancel();
    }

    return (
        <Modal
            width={width}
            open={Object.keys(item).length > 0}
            onCancel={() => onCancel()}
            onOk={() => onSubmit()}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0",
                body: "!p-[20px]",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            title={(
                <p className="m-0 font-[500]">
                    Alert
                </p>
            )}
            okText={okText || `Yes, Delete`}
            okButtonProps={{
                danger: true,
                loading: submitLoading
            }}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
        >
            {content ? content : <>Are you sure you want to delete this {title}?</>}
        </Modal>
    )
}

export default DeleteModalSimple